
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/images/whitelogo.png';
// 1. Import the Mail icon for the new component
import { FileText, Users, Clipboard, MessageSquare, User, Wallet, IndianRupee, List, MessageSquareText, Ticket, ShieldCheck, FileClock, Mail } from 'lucide-react';


import './Sidebar.css';

const Sidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname.split('/').pop(); 

  const navigationItems = [

    { id: 'userdetails', icon: Users, label: 'User Details' },
    { id: 'reports', icon: FileText, label: 'Reports ' },
    { id: 'counsellings', icon: User, label: 'Counsellings' },
    { id: 'loading-facts', icon: FileClock, label: 'Loading Facts' },
    { id: 'forum-admin', icon: ShieldCheck, label: 'Forum Management' },
    // 2. Add the new "Email Marketing" link
    { id: 'email-marketing', icon: Mail, label: 'Email Marketing' },
    { id: 'packages', icon: Wallet, label: 'Payment Packages' },
    { id: 'payments', icon: IndianRupee, label: 'Payments' },
    { id: 'coupon', icon: Ticket, label: ' Coupons' },

    { id: 'list', icon: List, label: 'List' },
    { id: 'prompt', icon: MessageSquareText, label: 'Prompt' },
    // { id: 'emailtemplate', icon: Clipboard, label: 'Email Template' }
  ];

  const handleNavigate = (path) => {
    navigate(`/admin/${path}`);
  };

  return (
    <div
      className="sidebar-container"
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <div className={`sidebar ${isExpanded ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="sidebar-header">
          <img className="sidebar-logo-img" src={logo} alt="Company Logo"/>
          <span className="sidebar-logo-text">GN-VISA</span> 
        </div>

        <nav className="sidebar-nav">
          {navigationItems.map(item => {
            const Icon = item.icon;
            return (
              <div
                key={item.id}
                data-tooltip={item.label}
                className={`nav-item ${activeTab === item.id ? 'nav-item-active' : ''}`}
                onClick={() => handleNavigate(item.id)}
              >
                <span className="nav-icon">
                  <Icon size={22} />
                </span>
                <span className="nav-text">{item.label}</span>
              </div>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;